// extracted by mini-css-extract-plugin
export default {"content":"style_content__+lEqZ","form":"style_form__EMKuK","info":"style_info__6wQPp"};